import script from "./WaitLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitLibrary.vue?vue&type=script&setup=true&lang=js"

import "./WaitLibrary.vue?vue&type=style&index=0&id=7f0c0455&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0c0455"]])

export default __exports__